import './polyfills';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TonConnectUIProvider, THEME } from '@tonconnect/ui-react';
import { MANIFEST_URL } from './ton/config';
import { App } from './App';
import { LegalPage, type LegalPageKind } from './components/LegalPage';
import { PartnerApp } from './partner/PartnerApp';
import './styles/index.css';

// Telegram Mini App bootstrap (no-op outside Telegram).
window.Telegram?.WebApp?.ready();
window.Telegram?.WebApp?.expand();

// Telegram macOS (WKWebView) keeps painting a stale hybrid layout after the
// client resizes the mini-app window: JS geometry is correct, but the render
// mixes old and new widths and content bleeds past the right edge. Rebuild
// layout and paint from scratch whenever the window width actually changes.
if (window.Telegram?.WebApp) {
  let lastWidth = window.innerWidth;
  let scheduled = false;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth || scheduled) return;
    lastWidth = window.innerWidth;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const root = document.documentElement;
      const prev = root.style.display;
      root.style.display = 'none';
      void root.offsetHeight;
      root.style.display = prev;
    });
  });
}

// The service worker exists only to make the site installable as a PWA
// ("Add to Home Screen"); it caches nothing.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
}

const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
const isPartnerRoute = pathname === '/partner';
const legalPage: LegalPageKind | null =
  pathname === '/terms' ? 'terms' : pathname === '/privacy' ? 'privacy' : null;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {legalPage ? (
      <LegalPage kind={legalPage} />
    ) : (
      <TonConnectUIProvider
        manifestUrl={MANIFEST_URL}
        uiPreferences={{ theme: THEME.DARK, colorsSet: { [THEME.DARK]: { accent: '#e9c46a', telegramButton: '#e9c46a' } } }}
      >
        {isPartnerRoute ? <PartnerApp /> : <App />}
      </TonConnectUIProvider>
    )}
  </StrictMode>,
);
